import { Component, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as feather from 'feather-icons';
import { DialogCompassComponent } from 'src/app/dialogs/dialog-compass/dialog-compass.component';
import { DialogProficiencyComponent } from 'src/app/dialogs/dialog-proficiency/dialog-proficiency.component';

@Component({
    selector: 'app-introduction',
    templateUrl: './introduction.component.html',
    styleUrls: ['./introduction.component.css'],
    standalone: false
})
export class IntroductionComponent implements AfterViewInit {

  constructor(public dialog: MatDialog ) {}

  ngAfterViewInit() {
    feather.replace();
  }

  openCompassDialog() {
    this.dialog.open(DialogCompassComponent, { disableClose: true });
  }

  openProficiencyDialog() {
    this.dialog.open(DialogProficiencyComponent, { disableClose: true });
  }

}
